import React from 'react';
import '../../../App.css';
import './About.css';
import { Link } from 'react-router-dom';
import AboutLinks from '../AboutLinks';

function History() {
  return (
    <div>
        <div className='hero-container history half'>
            <h1></h1>
         </div>
      <div className='main-grid-container'>
        <div className='main-grid-item'>
      <AboutLinks/>
      </div>
      <div className='main-grid-item'>
      <div className='main with-sublinks'>
        <h1>History</h1>
        <p>
        ln January of 2007, a number of families who had been attending Bible studies together for several years stepped out in faith and formally established Grace Community Fellowship. <Link to='/about/leadership/larry-loden' className='p-link'>Larry Loden</Link>, a graduate of The Master's Seminary, was recognized as an elder during that time and set apart to provide oversight for the body. <br/><br/>
        Throughout the years, the saints of GCF have been defined by their desire to grow in the sanctifying knowledge of God’s word and help one another apply it to their lives. God has been gracious to mature and multiply this local body of believers over the years, and He continues to mature us, challenge us, and grow us to be fruitful vessels in His hands. It is by His grace and for His glory that GCF exists. Our sole mission is to see the testimony of Christ, the authority of Christ, and the gospel of Christ advance in the world so that sinners can come to saving faith in Him.
        </p>
      </div>
    </div>
    </div>
    </div>
  )
}

export default History
